<template lang="pug">
pr-wrapper#home.px-5.pt-5.d-flex.flex-column(fs, bg="overlayFrom", bgo=".95", bgd="45")
  .macAddress(v-if="showMac") {{ getMac }}
  .header.row.no-gutters.align-items-stretch
    .col.col-auto.pr-5(v-if="config['app_logo_visibility.app_logo_visibility'] === '1'")
      img.logo(:src="config['app_logo./uploads/']")
    .col.col-auto.px-4.d-flex.align-items-center.border-left(v-if="isWeatherEnabled")
      pr-subtitle.mr-3.font-weight-light {{ isWeatherEnabled.current.temp }}{{ isWeatherEnabled.icon }}
      icon.fa-2x(:icon="isWeatherEnabled.current.icon") 
    .col.col-auto.pl-4.d-flex.align-items-left.justify-content-center.flex-column.border-left(v-if="isDatetimeEnabled")
      pr-text
        moment(format="hh:mm A, dddd", date, live)
      pr-text
        moment(format="DD MMMM YYYY", date, live)
    .col.d-flex.align-items-center.justify-content-end
      info-bar(scope="infobar-home", data-down="main-menu")
  .content.flex-grow-1.d-flex.align-items-end
    .content-wrapper.w-100
      .d-flex.align-items-center
        pr-text(size="large", v-if="guest && showGuest") {{ $t("Welcome") }},
        pr-text(size="large", v-else) {{ $t("Welcome") }}
        pr-badge.ml-3(
          v-if="config['is_room_number_showing.is_room_number_showing'] === '1'",
          arrow="left",
          v-html="hasTitle || $t('Room', [device.location])"
        )
      pr-text.font-weight-bold(size="large", v-if="guest && showGuest") {{ `${guest.name} ${guest.surname}` }}
      .guest-additional.border-bottom.border-top.font-italic.py-2.d-inline-block(v-if="guest && guest.additional") {{ guest.additional }}

      .d-flex.mt-4
        .main-menu.flex-grow-1.overflow-hidden(
          @nv-numpad="$channelSelectWithNumber",
          v-nv:scope="'main-menu'",
          ref="main-menu",
          data-up="infobar-home",
          :class="{ fullscreen: navigationMustBeFull, 'pl-0': !$store.state.theme.options.scale }"
        )
          .scroll-container.position-relative.d-inline-block.animated(ref="scroll-container")
            .menu-item-container.themed.scale-sm.border.surface-bg-darker.onSurface-color(
              v-for="(menu, index) in menus",
              :key="menu.id",
              v-nv,
              @nv-enter="choose(menu)"
            )
              .menu-item-frame(:class="[menu.image_type, $store.state.theme.options.menu]")
                .image(:style="`background-image:url(${menu.image})`", v-if="menu.image_type === 'image'")
                .content
                  .content-icon(v-if="menu.image_type !== 'NULL'")
                    imagec(:src="menu.image", v-if="menu.image_type === 'iconi'") 
                    icon.fa-3x(:icon="menu.image", :type="menu.image_type", v-else-if="menu.image_type.includes('icon')") 
                  pr-text.content-title.pb-2(:style="{ 'font-size': $store.state.theme.font.menu }", v-if="menu.title && menu.isShow") {{ menu.title }}
        .homeplayer.border(v-show="!navigationMustBeFull")
          #homeplayer
</template>

<script>
import { mapGetters, mapState } from "vuex"
export default {
  name: "home",
  computed: {
    hasTitle() {
      return _$.true(__.device.get("title")) && __.device.get("title")
    },
    showGuest() {
      return _$.true(__.device.config("show_guest_name.show_guest_name"))
    },
    showMac() {
      return _$.true(__.device.config("show_mac_address_at_home.show_mac_address_at_home"))
    },
    getMac() {
      return __.device.get("mac")
    },
    isWeatherEnabled() {
      return _$.true(__.device.config("services.weather")) && this.$store.state.rss.weather
    },
    isDatetimeEnabled() {
      return _$.true(__.device.config("services.datetime"))
    },
    logo() {
      return this.config["app_logo./uploads/"]
    },
    bgVideo() {
      return this.config["home_page_video.home_page_video"]
    },
    bgVideoFullscreen() {
      return _$.true(this.config["home_page_video.home_page_video_frame"])
    },
    bgImage() {
      return this.config["app_bg./uploads/"]
    },
    navigationMustBeFull() {
      return this.bgVideoFullscreen || !this.bgVideo
    },
    ...mapState(["config", "guest", "menus", "device"]),
    ...mapGetters(["language"])
  },
  watch: {
    menus() {
      this.$nextTick(() => _$.nav.refreshScope("main-menu", true))
    }
  },
  activated() {
    this.initBackground()
    _$.nav.changeScope("main-menu")
  },
  mounted() {
    _$.nav.sync("main-menu")
    if (this.$refs["scroll-container"].offsetHeight < this.$refs["main-menu"].offsetHeight - 50) {
      this.$refs["main-menu"].style.height = "auto"
      this.$refs["main-menu"].style.paddingTop = "0px"
    }
  },
  methods: {
    async choose(menu) {
      if (menu.hasOwnProperty("subs")) {
        const subs = menu.subs.map(sub => {
          return { key: sub.id, value: sub.title, type: sub.image_type, image: sub.image, selected: false }
        })
        const res = await _$.vue.$sidepane(menu.title, null, subs, "left")
        if (!res) return false
        return this.choose(menu.subs.find(sub => sub.id === res))
      }
      if (["live", "live", "cms", "chromecast"].includes(menu.module) && menu.target) __.platform.go(`/${menu.module}/${menu.target}`)
      else if (["live", "live", "cms", "chromecast"].includes(menu.module)) __.platform.go(`/${menu.module}`)
      else __.platform.go({ name: menu.module, title: menu.title, params: { target: menu.target } })
    },
    initBackground() {
      if (this.bgImage) __.platform.background(this.bgImage, this.bgVideo)
      else if (this.bgVideo) __.media.play(this.bgVideo, true)

      if (this.bgVideo) __.common.tvWindowResize(this.navigationMustBeFull ? false : "homeplayer")
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  .logo {
    max-height: 80px;
  }
}

.content {
  .main-menu {
    height: 280px;
    padding: 10px 10px 14px;
    margin-left: -10px;
    .scroll-container {
      .menu-item-container {
        float: left;
        max-width: 228px;
        min-width: 228px;
        height: 110px;
        margin: 10px;
        position: relative;
        overflow: hidden;

        .menu-item-frame {
          position: absolute;
          display: flex;
          flex-direction: column;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;

          &.horizontal.flat-icon,
          &.horizontal.fa-icon,
          &.horizontal.iconi {
            .content {
              flex-direction: row !important;
              justify-content: center;
              align-items: center;
              .content-icon {
                flex: 0;

                .fa-3x {
                  font-size: 2em;
                }

                .imagec {
                  width: 2.2em;
                }
              }
              .content-title {
                padding: 0 0 0 10px !important;
              }
            }
          }
          &.NULL {
            .content {
              justify-content: center;
              align-items: center;
            }
            .content-title {
              padding: 0 !important;
            }
          }

          .image {
            background-position: center center;
            background-size: cover;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 0;
            image-rendering: "auto";
          }

          .content {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            .content-icon {
              flex-grow: 1;
              align-items: center;
              display: flex;

              .imagec {
                width: 2.5em;
              }
            }
            .content-title {
              font-weight: 600;
            }
          }

          &.image {
            .content {
              .content-title {
                width: 100%;
                text-align: center;
                padding-top: 50px;
                background: -webkit-linear-gradient(90deg, rgba(0, 0, 0, 0.9) 20%, rgba(0, 0, 0, 0) 50%);
              }
            }
          }

          .fa-3x {
            font-size: 2.5em;
          }
        }

        &.nv-el-current {
          border-width: 3px !important;
        }
      }
    }

    &.fullscreen {
      height: 260px;
      .scroll-container {
        .menu-item-container {
          max-width: 210px;
          min-width: 210px;
          height: 100px;
        }
      }
    }
  }
  .homeplayer {
    max-width: 426px;
    min-width: 426px;
    margin-top: 10px;
    height: 240px;
    box-sizing: content-box;
    background: rgba(0, 0, 0, 1);
    position: relative;
    #homeplayer {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
}
.macAddress {
  position: absolute;
  bottom: 5px;
  z-index: 10;
  right: 50px;
  color: white;
}
</style>
